import type { TaskDetailDto } from '@ovo/shared'
import { useState } from 'react'
import { useTaskAction } from '../api/hooks.ts'
import { shortName } from '../lib/status.ts'
import { Button } from './Button.tsx'
import { Input } from './Input.tsx'
import { Section } from './List.tsx'

// Подпункты задачи: отметить пункт, добавить новый. Права проверяет сервер, здесь — только подсказки.

export function Checklist({ task, meId }: { task: TaskDetailDto; meId: number }) {
  const action = useTaskAction()
  const [text, setText] = useState('')
  const items = task.checklistItems
  const canToggle = task.allowedActions.includes('checklist_toggle')
  const canAdd = task.allowedActions.includes('checklist_add')
  const isCreator = task.relations.includes('creator')
  if (items.length === 0 && !canAdd) return null
  const done = items.filter((i) => i.done).length

  const add = (): void => {
    const t = text.trim()
    if (!t) return
    action.mutate(
      { taskId: task.id, command: { type: 'checklist_add', text: t }, silent: true },
      { onSuccess: () => setText('') },
    )
  }

  return (
    <Section
      id="checklist"
      title={items.length > 0 ? `Пункты · ${done} из ${items.length}` : 'Пункты'}
      padded
    >
      <div className="checklist">
        {items.map((i) => {
          const mine = i.assignee === null || i.assignee.id === meId || isCreator
          return (
            <button
              key={i.id}
              type="button"
              className={`checklist__item${i.done ? ' checklist__item--done' : ''}`}
              disabled={!canToggle || !mine || action.isPending}
              aria-pressed={i.done}
              onClick={() =>
                action.mutate({
                  taskId: task.id,
                  command: { type: 'checklist_toggle', itemId: i.id },
                  silent: true,
                })
              }
            >
              <span className="checklist__box" aria-hidden="true">
                {i.done ? '✓' : ''}
              </span>
              <span className="stack stack--xs">
                <span className="checklist__text">{i.text}</span>
                {i.assignee && (
                  <span className="checklist__who">
                    {i.assignee.id === meId ? 'ваш пункт' : shortName(i.assignee.displayName)}
                  </span>
                )}
              </span>
            </button>
          )
        })}
        {canAdd && (
          <div className="row">
            <Input
              aria-label="Новый пункт"
              placeholder="Добавить пункт"
              value={text}
              maxLength={200}
              enterKeyHint="done"
              onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') add()
              }}
            />
            <Button size="sm" variant="secondary" disabled={!text.trim() || action.isPending} onClick={add}>
              Добавить
            </Button>
          </div>
        )}
      </div>
    </Section>
  )
}
